// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { func, oneOf, oneOfType, string, node, bool } from 'prop-types';
import {
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Loading
} from '@carbon/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

const StyledComposedModal = styled(ComposedModal)`
  .cds--modal-content {
    margin: 0;
    padding-block: unset;
  }

  &.UnavailableProductsConfirmationModal,
  &.OfferPriceChangesModal {
    .cds--modal-header {
      align-items: center;
      display: flex;
      min-height: 64px;
    }

    .cds--modal-header__heading {
      margin: 0;
    }
  }
`;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: none !important;
  padding: 0 !important;
`;

const PromptModal = memo(props => {
  const {
    loading,
    header,
    body,
    size,
    className,
    footer,
    open,
    error,
    confirmButton,
    cancelButton,
    showCancelButton = true,
    onConfirm,
    onCancel
  } = props;

  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <StyledComposedModal
      open={ open }
      onClose={ onCancel }
      size={ size }
      theme={ theme }
      danger={ !!error }
      className={ `${className} PromptModal` }
      selectorPrimaryFocus=".cds--modal-content"
    >
      <ModalHeader>
        { header }
      </ModalHeader>
      <ModalBody>
        { body }
      </ModalBody>
      <ModalFooter>
        { footer
        || (
          <>
            <StyledButton
              className="red submit"
              type="submit"
              disabled={ loading }
              onClick={ onConfirm }
              kind="primary"
            >
              { loading && <Loading active withOverlay={ false } small /> }
              { confirmButton || t('common.confirm') }
            </StyledButton>
            { showCancelButton && (
              <StyledButton
                kind="ghost"
                className="red"
                onClick={ onCancel }
                disabled={ loading }
                tabIndex={ -1 }
              >
                { cancelButton || t('common.cancel') }
              </StyledButton>
            ) }
          </>
        ) }
      </ModalFooter>
    </StyledComposedModal>
  );
});

PromptModal.propTypes = {
  error: string,
  className: string,
  header: oneOfType([string, node]),
  body: oneOfType([string, node]),
  footer: oneOfType([string, node]),
  loading: bool,
  open: bool,
  showCancelButton: bool,
  size: oneOf(['xs', 'sm', 'md', 'lg']),
  cancelButton: string,
  confirmButton: string,
  onConfirm: func,
  onCancel: func
};

PromptModal.defaultProps = {
  size: 'sm'
};

PromptModal.displayName = 'PromptModalComponent';

export default PromptModal;
